import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { getAssetEventSelectorId } from '../../utils/hsAnalytics';
import AssetDemoModal from './AssetDemoModal';
import { useOfferingType } from '../../context/OfferingTypeContext';

const AssetDemoButton = (_ref) => {
  let {
    exampleUrl,
    modalPrimaryButton,
    name,
    onClick,
    onTrackInteraction,
    onTrackPageview,
    providerName,
    section,
    slug
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["exampleUrl", "modalPrimaryButton", "name", "onClick", "onTrackInteraction", "onTrackPageview", "providerName", "section", "slug"]);

  const [modalOpen, setModalOpen] = useState(false);
  const offeringType = useOfferingType();
  const handleClick = useCallback(evt => {
    setModalOpen(true);
    onTrackInteraction('click preview button', {
      section
    });

    if (onClick) {
      onClick(evt);
    }
  }, [onClick, onTrackInteraction, section]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIButton, Object.assign({}, rest, {
      "data-hs-analytics-id": getAssetEventSelectorId('PREVIEW', offeringType),
      onClick: handleClick,
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.assets.details.demoButton"
      })
    })), modalOpen && /*#__PURE__*/_jsx(AssetDemoModal, {
      exampleUrl: exampleUrl,
      name: name,
      onClose: () => {
        setModalOpen(false);
      },
      onTrackInteraction: onTrackInteraction,
      onTrackPageview: onTrackPageview,
      primaryButton: modalPrimaryButton,
      providerName: providerName,
      showShareButton: true,
      slug: slug
    })]
  });
};

export default AssetDemoButton;